export enum PriorityTier {
  CRITICAL = 'CRITICAL',  // 80-100
  HIGH = 'HIGH',          // 60-79
  MEDIUM = 'MEDIUM',      // 40-59
  LOW = 'LOW',            // 0-39
}

export enum ConversationPriorityState {
  IDLE = 'IDLE',
  NEW_INQUIRY = 'NEW_INQUIRY',
  BOOKING_IN_PROGRESS = 'BOOKING_IN_PROGRESS',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  PAYMENT_SENT = 'PAYMENT_SENT',
  PAYMENT_OVERDUE = 'PAYMENT_OVERDUE',
  PAID = 'PAID',
  CONFIRMED = 'CONFIRMED',
  APPOINTMENT_DAY = 'APPOINTMENT_DAY',
  COMPLETED = 'COMPLETED',
  NO_SHOW = 'NO_SHOW',
  CANCELLED = 'CANCELLED',
}

export interface UrgencyFactors {
  appointmentWithin2Hours: boolean;
  appointmentToday: boolean;
  appointmentTomorrow: boolean;
  paymentPendingOver24h: boolean;
  customerWaitingOver4h: boolean;
  customerWaitingOver1h: boolean;
  unreadMessageCount: number;
}

export interface ValueFactors {
  isHighValueCustomer: boolean;
  hasLargePendingOrder: boolean;
  isRepeatCustomer: boolean;
  isNewCustomer: boolean;
  isReferral: boolean;
  totalSpentCents: number;
  averageOrderCents: number;
}

export interface RiskFactors {
  complaintDetected: boolean;
  paymentOverdue: boolean;
  hasCancellationPattern: boolean;
  bookingIncompleteOver2h: boolean;
  unconfirmedTomorrow: boolean;
}

export interface OpportunityFactors {
  rebookingWindow: boolean;
  upsellContext: boolean;
  referralPotential: boolean;
  firstTimeConversion: boolean;
}

export interface ConversationPriority {
  conversationId: string;
  urgencyScore: number;
  valueScore: number;
  riskScore: number;
  opportunityScore: number;
  totalScore: number;
  tier: PriorityTier;
  state: ConversationPriorityState;
  primaryReason: string;
  recommendedAction: string;
  calculatedAt: Date;
}

export interface ConversationContext {
  conversationId: string;
  state: ConversationPriorityState;
  urgencyFactors: UrgencyFactors;
  valueFactors: ValueFactors;
  riskFactors: RiskFactors;
  opportunityFactors: OpportunityFactors;
}
